import { type ComponentPropsWithoutRef, memo } from 'react';

import { type Clip } from '@air/api/types';
import { FileExtensionPreview, type FileExtensionPreviewSize } from '@air/component-file-extension-preview';
import { cn } from '@air/utils-tailwind';

export type AssetGalleryCardProcessingProps = Pick<Clip, 'ext'> &
  Pick<ComponentPropsWithoutRef<'div'>, 'className'> & {
    previewClassName?: string;
    previewSize?: FileExtensionPreviewSize;
  };

export const AssetGalleryCardProcessing = memo(
  ({ className, ext, previewClassName, previewSize = 'medium' }: AssetGalleryCardProcessingProps) => {
    return (
      <div
        className={cn(
          'shimmer-background relative flex flex-1 flex-col items-center justify-center ads:bg-ads-gray-4 bg-gray-4',
          className,
        )}
      >
        <FileExtensionPreview
          ext={ext}
          text="Processing"
          color="gray"
          size={previewSize}
          className={cn('grow justify-center', previewClassName)}
        />
      </div>
    );
  },
);

AssetGalleryCardProcessing.displayName = 'AssetGalleryCardProcessing';
